import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="relative">
      {/* Footer Content */}
      <div className="bg-blue-600 pt-16 pb-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-white">
            Copyright © GlobalAspire 2025. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 